import { render } from "./ReportPosts.vue?vue&type=template&id=3f312116&ts=true"
import script from "./ReportPosts.vue?vue&type=script&lang=ts"
export * from "./ReportPosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__